// react and js

// mui

// components

// hooks

// layouts

// pages

// theme

// utils

// widgets

// ----------------------------------------------------------------------
// Code
// ----------------------------------------------------------------------
let scriptPromise = null;

function loadScript() {
  if (scriptPromise) return scriptPromise;

  const sitekey = process.env.REACT_APP_RECAPTCHA_V3_SITEKEY;
  if (!sitekey || typeof window === "undefined") {
    scriptPromise = Promise.reject(
      new Error("reCAPTCHA v3 unavailable")
    );
    return scriptPromise;
  }

  scriptPromise = new Promise((resolve, reject) => {
    if (window.grecaptcha && window.grecaptcha.execute) {
      resolve();
      return;
    }

    const existing = document.querySelector("script[data-recaptcha-v3]");
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", () =>
        reject(new Error("reCAPTCHA v3 script failed"))
      );
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${sitekey}`;
    script.async = true;
    script.defer = true;
    script.setAttribute("data-recaptcha-v3", "true");
    script.onload = () => resolve();
    script.onerror = () => reject(new Error("reCAPTCHA v3 script failed"));
    document.head.appendChild(script);
  });

  return scriptPromise;
}

// ----------------------------------------------------------------------
// Properties
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// Main element export(s)
// ----------------------------------------------------------------------
export function preloadRecaptchaV3() {
  loadScript().catch(() => {});
}

export async function executeRecaptchaV3(action) {
  const sitekey = process.env.REACT_APP_RECAPTCHA_V3_SITEKEY;
  if (!sitekey || typeof window === "undefined") return "";

  try {
    await loadScript();
    await new Promise((resolve) => {
      window.grecaptcha.ready(resolve);
    });
    return await window.grecaptcha.execute(sitekey, { action });
  } catch {
    return "";
  }
}
